import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

const decorationLabels: Record<string, string> = {
  without: 'Без отделки',
  rough: 'Черновая отделка',
  preFine: 'Предчистовая отделка',
  fine: 'Чистовая отделка',
  fineWithFurniture: 'Чистовая отделка с мебелью',
};

export const hasDecorationDefinition = definitionFactory({
  key: 'decorations_list',
  mapper: (jsonQueryValue, _tags, appState) => {
    const decorationsList = appState.jsonQuery.decorations_list?.value;

    if (!decorationsList || !Array.isArray(decorationsList) || decorationsList.length === 0) {
      return [];
    }

    return decorationsList.map(decoration => ({
      label: decorationLabels[decoration] || decoration,
      value: decoration,
    }));
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'decorations_list', options);
  },
});
